import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import ShadowBox from '../common/ShadowBox'
import ShadowBoxTitle from '../common/ShadowBoxTitle'
import CaseList from './CaseList'
import style from './style.module.less'

@inject('sessionCaseStore')
@observer
export default class extends Component {
  componentDidMount() {
    this.props.sessionCaseStore.init()
  }
  render() {
    const store = this.props.sessionCaseStore
    return (
      <div className={style.content}>
        <ShadowBox>
          <ShadowBoxTitle store={store} />
          <CaseList store={store} />
        </ShadowBox>
      </div>
    )
  }
}
